import { Component, OnInit } from '@angular/core'
import { doc, docData } from '@angular/fire/firestore'
import { AdminService } from '../../../services/admin.service'
import { ActivatedRoute } from '@angular/router'
import { Blog, blogsPath, Image } from '@parkupp/core'

@Component({
    selector: 'app-blog-page',
    templateUrl: './blog-page.component.html',
    styleUrls: ['./blog-page.component.scss'],
})
export class BlogPageComponent implements OnInit {
    blogKey: string
    blog: Blog
    blogImage: Image
    publishDate: string

    constructor(private adminService: AdminService, private activatedRoute: ActivatedRoute) {
        this.blogKey = this.activatedRoute.snapshot.params['blogKey']

        docData(doc(this.adminService.firestore, blogsPath(), this.blogKey)).subscribe((documentData: any) => {
            this.blog = new Blog(documentData)
            this.blog.$key = this.blogKey
            this.blogImage = this.blog.blogImage
            this.publishDate = new Date(this.blog.createdAt.toDate()).toLocaleDateString()
        })
    }

    ngOnInit(): void {}

    stripNewLines(html: string) {
        return html.replace(/\n/g, '')
    }
}
